import { Download } from 'lucide-react';
import { isTauri } from '@/lib/platform';
import { cn } from '@/lib/utils';
import { BRAND_DOWNLOADS } from '@/lib/brand';

/** Installers published by deploy/scripts/publish-desktop.sh, served by Caddy next to the web app (names from the brand). */
const INSTALLERS = {
  windows: { label: 'the desktop app for Windows', href: BRAND_DOWNLOADS.windows },
  mac: { label: 'the desktop app for Mac', href: BRAND_DOWNLOADS.mac },
  android: { label: 'the Android app', href: BRAND_DOWNLOADS.android },
} as const;

/** Windows, Mac and Android browsers (not iPhone/iPad yet), and never inside the desktop app itself. */
function desktopOs(): keyof typeof INSTALLERS | null {
  if (isTauri || typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return 'android';
  if (/iPhone|iPad|iPod/i.test(ua)) return null;
  if (/Windows/i.test(ua)) return 'windows';
  // iPadOS reports itself as a Mac; a touch screen gives it away.
  if (/Macintosh|Mac OS X/i.test(ua) && navigator.maxTouchPoints <= 1) return 'mac';
  return null;
}

export function DesktopDownload({ className }: { className?: string }) {
  const os = desktopOs();
  if (!os) return null;
  const { label, href } = INSTALLERS[os];
  return (
    <a
      href={href}
      download
      className={cn('inline-flex items-center gap-2 text-xs text-muted-foreground transition-colors hover:text-foreground', className)}
    >
      <Download className="size-3.5" />
      Get {label}
    </a>
  );
}
